import React from 'react';

export const FieldLabel = props => {
    const { className, children } = props;
    return <small className={`${className} text-muted text-uppercase`}>{children}</small>;
};
